import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Device, User, UserDeleteConfirmation, ConfirmationData, } from '../../models'
import { DeviceService } from './../../services/device.service'
import { ConfirmDialog } from '../../views/dialog/confirm.dialog'
import { MatDialog } from '@angular/material'
@Component({
  selector: 'manage-users',
  styleUrls: ['./modal-mod.css'],
  templateUrl: './manage-users.modal.html'
})
export class ManageUsersModal {
  @Input() public device: Device
  @Input() public allUsers: User[]
  @Output() public allUsersChange: EventEmitter<User[]> = new EventEmitter()
  @Output() public deviceChange: EventEmitter<Device> = new EventEmitter()

  public userSearchInput
  public userSearchInput2

  constructor(private _deviceService: DeviceService, private dialog: MatDialog) { }

  public removeUserFromDevice(user: User) {
    this.dialog.open(ConfirmDialog, {
      data: new ConfirmationData(),
      minWidth: '200px'
    }).afterClosed()
      .subscribe((data) => {
        if (data && data.confirmed) {
          this._deviceService.removeDeviceFromUser(user._id, this.device._id).subscribe(
            (data) => {
              this.allUsers.unshift(user)
              this.device.users = this.device.users.filter(function (u) {
                return u._id !== user._id
              })
              this.updateParent()
            },
            (error) => { }
          )
        }
      });
  }

  public addUserToDevice(user: User) {
    this._deviceService.addDeviceToUser(user._id, this.device._id).subscribe(
      (data) => {
        this.device.users.unshift(user)
        this.allUsers = this.allUsers.filter(function (u) {
          return u._id !== user._id
        })
        this.updateParent()
      },
      (error) => { }
    )
  }

  private updateParent() {
    this.allUsersChange.emit(this.allUsers)
    this.deviceChange.emit(this.device)
  }
}
